import { render, staticRenderFns } from "./community.vue?vue&type=template&id=b7e837ca&scoped=true&"
import script from "./community.vue?vue&type=script&lang=js&"
export * from "./community.vue?vue&type=script&lang=js&"
import style0 from "./community.vue?vue&type=style&index=0&id=b7e837ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e837ca",
  null
  
)

export default component.exports